import {
	ToothEndodontic,
	ToothEndodonticPain,
	ToothEndodonticTest,
	ToothEndodonticTestResult,
	ToothEndodonticTestResultNotApplicable,
	ToothEndodonticTestResultPositive,
} from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';

const TRANSLATION_MAP: Record<string, string> = {
	[ToothEndodonticTestResult.NotApplicable]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.notApplicable',
	[ToothEndodonticTestResult.Negative]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.negative',
	[ToothEndodonticTestResult.Uncertain]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.uncertain',
	[ToothEndodonticTestResult.Positive]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.positive',
	[ToothEndodonticTestResultNotApplicable.ExistingRootCanalTreatment]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.existingRootCanalTreatment',
	[ToothEndodonticTestResultNotApplicable.PreviouslyInitiatedTherapy]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.previouslyInitiatedTherapy',
	[ToothEndodonticTestResultPositive.PainLingering]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.painLingering',
	[ToothEndodonticTestResultPositive.PainStimulus]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.painStimulus',
	[ToothEndodonticTestResultPositive.WithinLimits]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.withinLimits',
	[ToothEndodonticTestResultPositive.Unpleasant]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.unpleasant',
	[ToothEndodonticPain.Painful]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.painful',
	[ToothEndodonticPain.NotPainful]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.notPainful',
};

const handleDefaultValue = (value?: string) => {
	return value || 'patientTreatment.meddiDENT.dentalCross.endodontic.test';
};

export const getTestButtonText = (
	type: keyof ToothEndodontic,
	endodontic: ToothEndodontic,
) => {
	const { t } = useTranslation();

	const endodonticItem = endodontic[type];

	if (type === 'cold' || type === 'heat') {
		const test = endodonticItem as ToothEndodonticTest | undefined;

		const builtButtonText = [
			test?.result,
			test?.resultPositive,
			test?.resultNotApplicable,
		]
			.filter((item): item is NonNullable<typeof item> => Boolean(item))
			.map(item => t(TRANSLATION_MAP[item]))
			.join(', ');

		return handleDefaultValue(builtButtonText);
	}

	if (type === 'electric') {
		const electric = endodonticItem as number | undefined;
		return handleDefaultValue(electric?.toString());
	}

	if (type === 'percussion' || type === 'palpation') {
		const pain = endodonticItem as ToothEndodonticPain | undefined;
		return pain ? TRANSLATION_MAP[pain] : handleDefaultValue();
	}

	return handleDefaultValue();
};
